import { Grid } from "@mui/material"


import './index'
import { useCallback } from "react";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import TableContracts from "../documents/TableContracts";
import { EMPLOYEE_CONTRACTS_ONE, EMPLOYEE_CONTRACTS_THREE, EMPLOYEE_CONTRACTS_TWO } from "../../../constants/signalRequestConsts";

const getDefaultDate = (months: number) => {
    const newDate = new Date();
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}

const Contracts = () => {

    const ComponentOne = () => (
        <TableContracts
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            requestId={EMPLOYEE_CONTRACTS_ONE}
            status={2}
            hiddenFilterOptions={false}
        />
    );
    
    const ComponentTwo = useCallback(() => (
        <TableContracts
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            startDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_CONTRACTS_TWO}
            status={0}
            hiddenFilterOptions={true}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);
    
    const ComponentThree = useCallback(() => (
        <TableContracts
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            endDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_CONTRACTS_THREE}
            status={1}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), []);

    
    return (
        <Grid  container >

            <ThreeComponent
                useTabsNameAsTitle={true}
                tabsTitle={["No firmados", "Ultimos 6 meses", "Histórico"]}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Grid>
    )

}

export default Contracts